import { apiClient } from './../client';
import { API_ENDPOINTS } from './../constant/endpoints';
import type { IApiResponse } from './../types';
import type { ISearchResponse } from '@/features/command-center/types';

export const searchApi = {
    query: (q: string, signal?: AbortSignal) =>
        apiClient
            .get<IApiResponse<ISearchResponse>>(API_ENDPOINTS.SEARCH.QUERY, {
                params: { q },
                signal,
            })
            .then((r) => r.data.data),
};
